import { supportContact } from "../../constants/constants";
import { ErrorLinks, ContactDetails } from "./ErrorContactDetails.style";

const ErrorContactDetails = () => {
  return (
    <div>
      <p>Need help?</p>
      <p style={{ marginTop: "8px" }}>
        {"Email: "}
        <ErrorLinks
          href={`mailto:${supportContact.email}?subject=${supportContact.subject}`}
        >
          {supportContact.email}
        </ErrorLinks>
      </p>
      <p style={{ marginTop: "8px" }}>
        {"Call: "}
        <ErrorLinks href={`tel:${supportContact.phoneNumber}`}>
          {supportContact.phoneNumber}
        </ErrorLinks>
      </p>
      <ContactDetails>{supportContact.contactTimes}</ContactDetails>
    </div>
  );
};

export default ErrorContactDetails;
